module.exports = __webpack_public_path__ + "img/14.41f295d7.png";